module.exports = __webpack_public_path__ + "img/womanImg.304d5f7c.png";